const encode = value => encodeURIComponent(value || '');

const formatSharePreviewCacheKey = date => {
  if (date) {
    return date.replace(/-/g, '');
  }

  return new Date()
    .toISOString()
    .slice(0, 10)
    .replace(/-/g, '');
};

export const getSharePreviewImageUrl = ({ date } = {}) => {
  const cacheKey = formatSharePreviewCacheKey(date);

  return `${process.env.APP_MINFIN_API_DOMAIN}/share/currency/latest/?v=${cacheKey}`;
};

export const getSocialShareUrl = ({ actionId, pageUrl, shareText }) => {
  const encodedPageUrl = encode(pageUrl);
  const encodedShareText = encode(shareText);

  switch (actionId) {
    case 'telegram':
      return `tg://msg_url?url=${encodedPageUrl}&text=${encodedShareText}`;
    case 'viber':
      return `viber://forward?text=${encodedShareText}%20${encodedPageUrl}`;
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedPageUrl}`;
    case 'x':
      return `https://twitter.com/intent/tweet?text=${encodedShareText}&url=${encodedPageUrl}`;
    default:
      return '';
  }
};

export const openExternalShareUrl = (shareUrl, actionId) => {
  if (!shareUrl || typeof window === 'undefined') {
    return;
  }

  if (actionId === 'viber') {
    const fallbackUrl = 'https://www.viber.com/';
    const fallbackTimer = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.open(fallbackUrl, '_blank', 'noopener,noreferrer');
      }
    }, 1200);

    window.location.href = shareUrl;
    window.addEventListener(
      'visibilitychange',
      () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(fallbackTimer);
        }
      },
      { once: true }
    );
    return;
  }

  if (actionId === 'telegram') {
    const fallbackUrl = shareUrl.replace(
      /^tg:\/\/msg_url\?/,
      'https://t.me/share/url?'
    );
    const fallbackTimer = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.open(fallbackUrl, '_blank', 'noopener,noreferrer');
      }
    }, 1200);

    window.location.href = shareUrl;
    window.addEventListener(
      'visibilitychange',
      () => {
        if (document.visibilityState === 'hidden') {
          clearTimeout(fallbackTimer);
        }
      },
      { once: true }
    );
    return;
  }

  window.open(shareUrl, '_blank', 'noopener,noreferrer');
};

export const copyImageToClipboard = async blob => {
  if (
    typeof navigator === 'undefined' ||
    !navigator.clipboard ||
    typeof navigator.clipboard.write !== 'function' ||
    typeof ClipboardItem === 'undefined'
  ) {
    return false;
  }

  await navigator.clipboard.write([
    // eslint-disable-next-line no-undef
    new ClipboardItem({
      [blob.type || 'image/png']: blob,
    }),
  ]);

  return true;
};

export const downloadFile = ({ blob, filename }) => {
  if (typeof window === 'undefined') {
    return;
  }

  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
};
